import { render, staticRenderFns } from "./AdminDocuments.vue?vue&type=template&id=4d5e21dc&"
import script from "./AdminDocuments.vue?vue&type=script&lang=js&"
export * from "./AdminDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports